<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :collapse="true">
      <template slot="header">搜索</template>

      <el-form :model="search"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()"
               ref="searchForm">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称" prop="keyword">
            <el-input placeholder="请输入客户名称"
                      v-model="search.keyword"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="show_filter">
            <el-select v-model="search.show_filter"
                       placeholder="请选择是否显示"
                       class="width-max"
                       clearable>
              <el-option
                  v-for="item in [{label: '显示', value: '1'}, {label: '不显示', value: '0'}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">

              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit"
                     size="mini">搜索
          </el-button>
          <el-button @click="resetForm('searchForm')"
                     size="mini">重置
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/customer-task/create'">
          <el-button type="primary"
                      icon="sj-icon-add"
                      size="small">添加
          </el-button>
        </router-link>
      </div>

      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="80"></el-table-column>
        <el-table-column prop="number"
                         label="客户编号"
                         min-width="100">
        </el-table-column>
        <el-table-column prop="name"
                         label="客户名称"
                         min-width="150">
          <template slot-scope="scope">
            <span class="link" @click="jumpToCustomerProjectTale(scope.row)">{{scope.row.name}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="show_in_statistics"
                         label="是否显示"
                         min-width="50">
          <template slot-scope="scope">
          <span v-for="item in options.showInStatistics"
                v-if="scope.row.show_in_statistics === item.value">{{item.label}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="company"
                         label="所属公司"
                         min-width="100"></el-table-column>

        <el-table-column prop="type"
                         label="客户类型"
                         min-width="90">
          <template slot-scope="scope">
          <span v-for="item in optionModel.customerType"
                v-if="scope.row.type === item.value">{{item.label}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="managementfees"
                         label="管理费比例"
                         min-width="90">
          <template slot-scope="scope">
            <span>{{scope.row.managementfees * 100 | toFixed(1) }}%</span>
          </template>
        </el-table-column>

        <el-table-column prop="adminname"
                         label="客户联系人"
                         min-width="90">
          <template slot-scope="scope">{{ getContactPerson(scope.row, 'name') }}</template>
        </el-table-column>

        <el-table-column prop="phone"
                         label="联系方式"
                         min-width="90">
          <template slot-scope="scope">{{ getContactPerson(scope.row, 'phone') }}</template>
        </el-table-column>

        <el-table-column prop="email"
                         label="邮箱"
                         min-width="90">
          <template slot-scope="scope">{{ getContactPerson(scope.row, 'email') }}</template>
        </el-table-column>

        <el-table-column prop="detail"
                         label="描述"
                         min-width="90"></el-table-column>

        <el-table-column prop="createtime"
                         label="创建时间"
                         min-width="90">
          <template slot-scope="scope">
            <span>{{formatDate(scope.row.createtime)}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="updatetime"
                         label="最后更新时间"
                         min-width="90">
          <template slot-scope="scope">
            <span>{{formatDate(scope.row.updatetime)}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right"
                         label="操作" width="200">
          <template slot-scope="scope">
            <button-gutter>
              <router-link :to="`/customer/detail/${scope.row.id}`">
                <el-button type="primary" size="mini">客户详情</el-button>
              </router-link>
              <el-button icon=""
                         type="primary"
                         size="mini"
                         @click="openDialog(scope.row)">开票信息
              </el-button>
              <router-link :to="`/customer-task/update/${scope.row.id}`">
                <el-button type="primary" size="mini">修改</el-button>
              </router-link>
<!--              <el-button type="danger" size="mini" @click="onDelete(scope.row.id)">删除</el-button>-->
              <el-button icon=""
                         type="info"
                         size="mini"
                         @click="$router.push({name: '客户关系', params: {id: scope.row.id}})">客户关系
              </el-button>
              <router-link :to="`/customer-project-report/table/${scope.row.id}`">
                <el-button type="primary" size="mini">项目报告</el-button>
              </router-link>
            </button-gutter>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
      <customer-receipt-form ref="receiptDialog"></customer-receipt-form>
    </layout-panel>

    <customer-batch-invoice-upload-dialog :visible="uploadDialogVisible"
                                          @closeDialog="closeCustomerInvoiceUploadDialog">
    </customer-batch-invoice-upload-dialog>

  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import CustomerReceiptForm from '@/views/customer/components/CustomerReceiptForm'
import table from '@core/mixins/table'
import customerMixins from '../customer.mixins'
import CustomerBatchInvoiceUploadDialog from '@views/customer/components/CustomerBatchInvoiceUploadDialog'

export default {
  mixins: [table, dateTimePicker, customerMixins],
  components: {CustomerReceiptForm, CustomerBatchInvoiceUploadDialog},
  data () {
    return {
      search: {
        show_filter: '',
        keyword: '',
        type: this.$route.params.type || null
      },
      optionModel: {
        customerType: [],
      },
      uploadDialogVisible: false,
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.customer.options,
    }),
  },

  created () {
    request.page('getCustomerTaskOptions').then(({data}) => {
      this.optionModel.customerType = this.optionModel.customerType.concat(data.customerType)
    })
  },

  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      params = filter.copyJson(params)
      return request.page('getCustomerTable', params).then((data) => {
        if (data.data && data.data.data && data.data.data.length > 0) {
          data.data.data = data.data.data.map((one) => {
            one.contact_persons = JSON.parse(one.contact_persons)
            return one
          })
        }
        return data
      })
    },
    formatDate (value) {
      return filter.formatUnix(value)
    },
    jumpToCustomerProjectTale (customer) {
      this.$store.commit('SELECTED_CUSTOMER', customer)
      this.$router.push('/project/table/' + customer.id)
    },
    jumpToCustomerForm (id) {

    },
    onDelete (id) {
      this.$confirm('确定要删除吗？', '警告', {type: 'warning'}).then(_ => {
        request.common('deleteCustomerData', {id}).then(_ => {
          this.$message.success('删除成功')
          this.onSearch()
        })
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    openDialog (row) {
      let customer = {}
      customer.customerid = row.id
      customer.number = row.number
      customer.name = row.name
      this.$refs.receiptDialog.openDialog(customer)
    },
    getContactPerson (row, field) {
      if (row.contact_persons && row.contact_persons.length > 0) {
        return row.contact_persons[0][field]
      }
      return ''
    }
  },
}
</script>

<style lang="scss"
       scoped>
.link {
  color: #409EFF;
  padding: 5px 10px;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/pages/CustomerTable.vue